import { useEffect, useState } from "react";
import CustomButton from "../component/button";
import { Modal } from "react-bootstrap";
import { personalitiesList } from "../component/skeletons/PersonalitiesList";
import { PostCallWithErrorResponse } from "../Api/ApiServices";
import { ApiConfig } from "../Api/ApiConfig";
import { toastMsg } from "../component/toast";

const traits = [
  { name: "Steadiness", color: "#4cd6b9", activeColr: "rgb(196, 255, 225)", behaviors: ["Patience", "Persistence", "Thoughtfulness"] },
  { name: "Influence", activeColr: "rgb(214, 201, 255)", color: "#b6a1fb", behaviors: ["Self Confidence", "Enthusiasm", "Friendliness"] },
  { name: "Dominance", activeColr: "rgb(255, 197, 205)", color: "#f17d8b", behaviors: ["Efficiency", "Independence", "Self Motivation"] },
  { name: "Conscientiousness", activeColr: "rgb(255, 239, 197)", color: "#fbc43c", behaviors: ["Accuracy", "Cooperativeness", "Sensitivity"] },
];


const personalityDescriptions = {
  "Pioneer": "A self-reliant, ambitious, dynamic, & competitive individual. They are in constant pursuit of innovative solutions & seek new horizons to achieve goals.",
  "Influencer": "An enthusiastic, persuasive, confident & verbally skilled individual that loves to socialize and inspire people. They have a genuine interest in contributing to creative ideas.",
  "Team Player": "A friendly, calm, loyal & flexible individual that is remarkably consistent. They prefer practical jobs & enjoy being part of a team.",
  "Logical Thinker": "A cautious, logical, hardworking & detail-oriented individual that seeks accuracy in every activity. They combine existing rules, facts, & structures to manage work effectively.",
  "Persuader": "An assertive, energetic & expressive individual that is capable of both direct dynamic action & charming sociability as needed. Thrives on challenges & works with determination & commitment to achieve goals.",
  "Achiever": "A dependable, tolerant, persistent & tenacious individual that pushes past obstacles to get the job done. Can be supportive under favorable conditions & demanding if the situation calls for it.",
  "Perfectionist": "A well planned, straight forward, dynamic & competitive individual that believes in getting things right & doesn't shy away from challenges to get things done. Prioritizes accuracy & delivers quality.",
  "Collaborator": 'An intuitive, cooperative, loyal and social individual with a "people first" motto bringing warmth and positivity to the team. Promotes harmony and teamwork through charm and persuasion.',
  "Assessor": "An expressive, detail-oriented, enthusiastic and persuasive individual that makes creative ideas serve practicality. They are critical thinkers and they keep pushing themselves in the quest for high-quality results.",
  "Implementor": "A methodical, dependable, practical, and diligent individual that goes to great lengths in achieving best results. Any job they take up will be completed with keen attention to detail and accuracy.",
  "Motivator": "An independent, self-confident, competitive and persistent individual with a high sense of responsibility. Their patience and proactivity draw people to them. Very sociable but can also be determined and assertive in demanding situations.",
  "Leader": "A self-driven, innovative, confident & dynamic individual that likes taking responsibility & has a constant drive to make things better. While they are ambitious & assertive, they are also considerate of the needs of others & bring the best out of everyone around them.",
  "Administrator": "A practical, detail-oriented and clear-minded individual that builds harmony in the team and delivers results. Plans and organizes as per the goals and strongly pushes to achieve them.",
  "Mediator": "A well-spoken, detail-oriented, productive, and friendly individual who is easy to collaborate with. Has the patience to find the best possible solution which is both creative and efficient."
};




const SupervisiorPersonality = (props) => {

  const { supervisorPers = '', selectedBehaviours = [], handleSave, setShowSuperVisior } = props

  const [isLoading, setIsLoading] = useState(false)


  const [isFourSelected, setIsFourSelected] = useState(false)

  const [selectedBehavoiur, setSelectedBehaviour] = useState(selectedBehaviours)

  const [applyRecmnted, setApplyRecomented] = useState(selectedBehaviours?.length == 4)

  const [personalities, setPersonaliies] = useState(Object.keys(personalityDescriptions))

  const [behaviorName, setBehaviorName] = useState('')

  const [showmodal, setShowmodal] = useState(false);

  const [selectedPersonality, setSelectedPersonality] = useState(supervisorPers)


  const [onePer, setOnePer] = useState([]);

  useEffect(() => {

    if (selectedBehaviours?.length === 4) {
      getPersonalities()
    }

  }, [])

  const handleShow = (rec, per) => {
    if (rec === "N/A" || rec === null) {
      setOnePer([]);
      return;
    }
    setShowmodal(true);
    setOnePer(personalitiesList.filter((x) => x.personality.trim() === rec.trim()));
  };


  const handleCloseModal = () => setShowmodal(false);

  const handleSelected = (behaviur) => {



    if (selectedBehavoiur.includes(behaviur)) {

      let tempBeh = selectedBehavoiur?.filter((i) => i != behaviur)

      setSelectedBehaviour(tempBeh)

    } else {
      if (selectedBehavoiur?.length >= 4) {

        setBehaviorName(behaviur)

        setIsFourSelected(true)


        return
      }


      setSelectedBehaviour([...selectedBehavoiur, behaviur])
    }



  }

  const handleChange = (index) => [

    selectedBehavoiur[index] = behaviorName,

    setSelectedBehaviour(selectedBehavoiur),

    setIsFourSelected(false)
  ]

  const getPersonalities = () => {


    if (selectedBehavoiur?.length < 4) {
      setApplyRecomented(false)
      toastMsg('error', 'Please Select 4 Behavior')
      return
    }

    setIsLoading(true)
    let payload = {
      b1: selectedBehavoiur[0],
      b2: selectedBehavoiur[1],
      b3: selectedBehavoiur[2],
      b4: selectedBehavoiur[3],
    }

    PostCallWithErrorResponse(ApiConfig.POST_GET_PERSONALITY_MATCHES, payload).then((res) => {

      if (res?.json?.succeded) {

        let personalites = res?.json?.response?.sort((a, b) => b.percentage - a.percentage)
        let per = []

        personalites?.forEach((i) => {
          per.push(i?.name)
        })

        setIsLoading(false)
        console.log(per);

        setApplyRecomented(true)
        setPersonaliies(per)

      }

    })
  }



  return (

    <div
      className="canLisContentWrap p-3 bg-ui-gray"
      style={{ borderRadius: "10px" }}
    >

      <div className="bg-ui-gray" style={{ marginTop: "10px" }}>
        <div
          className="flex-1 p-4 bg-white"
          style={{ padding: "10px", borderRadius: "15px" }}
        >
          <div className=" d-flex justify-content-between font-color-text">
            <div>
              <h3 className="fw-semibold font-size-h3" style={{ marginBottom: "5px" }}>
                Supervisor Personality
              </h3>

              <h4 className="font-size-h4 fw-semibold" style={{ marginBottom: "-5px", marginTop: '12px' }}>
                Step 1(Optional): Choose the Behaviors that are most commonly displayed by the Supervisor to get Personality Recommendations.
                <span
                  className="fw-medium font-size-h4 text-dark-ui"
                  style={{
                    marginLeft: '5px'
                  }}
                >
                  ( Please Select 4 behaviors <span
                    className="text-base fw-semibold"
                    style={{
                      backgroundColor: "var(--brand-primary)",
                      color: "white",
                      borderRadius: "20px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: "30px",


                    }}
                  >
                    {selectedBehavoiur?.length}/4

                  </span>
                  {" "})

                </span>
              </h4>
            </div>
            <div style={{ marginTop: "10px" }}>
              <CustomButton
                title="Apply"
                handleClick={getPersonalities}
                isLoading={isLoading}
              />
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-0">
            <div className="d-flex align-items-center" style={{ gap: "20px" }}>



              {/*

              <div style={{ display: "flex", alignItems: "center", marginLeft: "200px" }}>
                <label
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: "30px",
                    height: "15px",
                    marginRight: "5px",
                    cursor: "default",
                  }}
                >
                  <input
                    type="checkbox"
                    checked
                    readOnly
                    style={{ opacity: 0, width: 0, height: 0 }}
                  />
                  <span style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "#12B76A",
                    borderRadius: "34px",
                    transition: "0.3s"
                  }}></span>
                  <span style={{
                    position: "absolute",
                    top: "2px",
                    left: "16px",
                    width: "10px",
                    height: "10px",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    transition: "0.3s"
                  }}></span>
                </label>

                <span style={{
                  fontSize: "var(--font-size-h4)",
                  fontWeight: "500",
                  color: "#222225ff",
                  fontFamily: "Inter-Regular",
                }}>
                  Selected behaviors
                </span>
              </div> */}




            </div>



          </div>
          {/* <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "5px",
           
              marginTop: '10px'
            }}
          >
            <h4
              style={{
                color: "#344054",
                fontSize: "var(--font-size-h4)",
                fontWeight: "600",
                margin: 0,
              }}
            >
              Behaviors
            </h4>
          </div> */}

          <div
            className="row d-flex"
            style={{
              rowGap: "24px",
              marginTop: '15px'
            }}
          >
            {traits.map((trait, i) => (
              <div key={i} className="col-md-3">
                <div
                  className="d-flex align-items-center"
                  style={{
                    gap: "6px",
                    marginBottom: "5px",

                  }}
                >
                  <div
                    style={{
                      width: "12px",
                      height: "12px",
                      backgroundColor: trait.color,
                      borderRadius: "2px",
                    }}
                  ></div>
                  <span className="be-2 color-group-box font-color-text">{trait.name}</span>
                </div>


                {trait.behaviors.map((behaviorName, index) => (
                  <div
                    key={index}
                    className="card-box min-height"
                    style={{
                      backgroundColor: "#F4F5F7",
                      border: "0.3px solid #e6e6e6",
                      borderLeft: `7px solid ${trait.color}`,
                      borderRadius: "var(--radius-md)",
                      marginBottom: "8px",
                      padding: "5px 10px",
                      cursor: "pointer",
                      backgroundColor: selectedBehavoiur?.includes(behaviorName) ? trait?.activeColr : ""
                    }}
                  >

                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h3
                        className="font-color-text text-base text-slate"
                        style={{
                          margin: 0,
                          lineHeight: "1.45",
                          fontWeight: "normal",
                        }}
                      >
                        {behaviorName}
                      </h3>

                      <span className="select-label">
                        <label className="switch">
                          <input type="checkbox"
                            checked={selectedBehavoiur?.includes(behaviorName)}
                            onChange={() => handleSelected(behaviorName)}
                          />
                          <span className="slider round"></span>
                        </label>
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>



          {/* Step 2 Section */}
          <div style={{ marginTop: "30px" }} >
            <div className="d-flex justify-content-between align-items-center">
              <h4
                className="font-size-h4 fw-semibold"
                style={{
                  marginBottom: "15px",
                }}
              >
                Step 2 : Choose the Personality that best represents the Supervisor (Make
                4 Selections Above to Narrow down the List)
              </h4>
              <div style={{ marginTop: '-15px' }}>
                <CustomButton
                  title='Save'
                  handleClick={() => {
                    if (supervisorPers || selectedPersonality) {
                      toastMsg('success', 'Supervisor Personality Added Please Add/Update Group')
                    }




                    handleSave(prev => ({
                      ...prev,
                      selectedSupervisorPersonality: {
                        "personalityName": selectedPersonality?.trim(),
                        "personalityId": 0,
                        "isSelected": true,
                        "percentage": "string",
                        description: personalityDescriptions[selectedPersonality?.trim()]
                      },
                      supervisorBehaviours: selectedBehavoiur
                    }))

                    setShowSuperVisior(false)
                  }
                  }
                />
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(5, 1fr)",
                gap: "8px",

              }}
            >
              {personalities.map((p, i) => {
                p = p?.trim()
                return <div
                  key={i}
                  style={{
                    border: "1px solid #e6e9ef",
                    borderRadius: "12px",
                    boxShadow: "0 6px 18px rgba(16, 24, 40, 0.06)",
                    padding: "8px",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "12px",
                    cursor: "pointer",
                    transition: "transform 0.18s ease, box-shadow 0.18s ease",
                    minHeight: "140px",
                    border: selectedPersonality === p
                      ? "1px solid var(--brand-primary)"
                      : (applyRecmnted && i < 5)
                        ? "1px solid var(--ff-color-focus-ring-blue)"
                        : "none"

                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "none";
                    e.currentTarget.style.boxShadow =
                      "0 6px 18px rgba(16,24,40,0.06)";
                  }}
                  onClick={() => handleShow(p)}
                >

                  {/* <div
          style={{
            width: "44px",
            height: "44px",
            // borderRadius: "50%",
            // border: "2px solid #f59e0b",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // background: "#fff7ed",
            flexShrink: 0,
          }}
        > */}
                  {/* <span
            style={{
              fontWeight: "700",
              color: "#f97316",
              fontSize: "var(--font-size-h3)",
            }}
          >
            {p.name.charAt(0)}
          </span> */}
                  {/* </div> */}

                  {/* Text Section */}
                  <div style={{ flex: 1 }}>
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={{
                        marginBottom: "2px",
                      }}
                    >
                      <h4
                        className="fw-semibold text-dark-brand font-size-h4"
                        style={{
                          margin: 0,
                        }}
                      >
                        {p}

                      </h4>

                      <div onClick={(e) => e.stopPropagation()}>
                        <input
                          type="radio"
                          name="status"
                          checked={selectedPersonality === p}

                          onClick={() => {
                            if (selectedPersonality === p) {

                              setSelectedPersonality(""); // unselect if already selected
                            } else {
                              setSelectedPersonality(p); // select if new
                            }
                          }}

                        />
                      </div>

                    </div>

                    <p
                      className="text-base text-slate"
                      style={{
                        lineHeight: "1.45",
                        margin: 0,
                      }}
                    >
                      {personalityDescriptions[p.trim()]}
                    </p>
                  </div>

                </div>
              })}
            </div>







          </div>
        </div>
        <Modal
          style={{ zIndex: '10000' }}
          className='custom-modal-for-behavior-popup-big modal-lg'
          centered
          show={isFourSelected} // always shown
          onHide={() => {
            setIsFourSelected(false)
          }}
          dialogClassName="modal-h-650"
        >
          <Modal.Header closeButton className="custom-close-btn flex-column">
            <div>
              <h6 className="mb-1 mt-1 font-color-text font-size-h3 text-report-heading">
                Unable To Select <span className="text-blue-500">{behaviorName}</span>
              </h6>
            </div>

            <div>
              <h6
                className="mb-0 mt-1 font-size-h4 text-center text-slate"
              >
                You have <span className="text-rose">4 behaviors selected</span>.
                <br />
                Please <span className="text-rose">select one</span> that you want to <span className="text-rose">replace</span>.
              </h6>
            </div>
          </Modal.Header>

          <Modal.Body>
            <div className='behavor-popup-grid--v2'
            >
              {/* Static placeholder cards */}
              {
                selectedBehavoiur?.map((i, index) => {
                  return <div className="popup-behaviour-cards"

                    onClick={() => handleChange(index)}
                  >{i}</div>
                })
              }

            </div >
          </Modal.Body>

          <Modal.Footer>
            {/* Empty footer */}
          </Modal.Footer>
        </Modal>
        <Modal
          show={showmodal}
          onHide={handleCloseModal}
          dialogClassName="custom-modal position-relative modal-h-650"
          size="lg"
        >
          <div
            className="position-absolute btn btn-close"
            style={{ top: "25px", right: "20px", zIndex: "99" }}
            onClick={() => setShowmodal(false)}
          ></div>
          <Modal.Body>
            <div className="row">
              {onePer.map((personality, index) => (
                <div key={index} className="col border rounded-3 mx-2">
                  <div className="row">
                    <div className="col-12 bg-peach">
                      <div className="row justify-content-between align-items-center mt-5">
                        <div className="col-6">
                          <img src={personality.img_card} alt="card-image"></img>
                        </div>
                        <div className="col-6">
                          <div className="row flex-column align-items-center">
                            <div className="col-6 d-flex justify-content-center ">
                              <img
                                width={50}
                                src={personality.img_letter}
                                alt="card-image-letter"
                              />
                            </div>
                            <div className="col-12">
                              <p
                                className="text-center fw-semibold"
                                style={{
                                  fontSize: "var(--font-size-h1)",
                                  lineHeight: "60px",
                                }}
                              >
                                {personality.personality}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="row justify-content-end">
                        <div className="col-12 my-4 d-flex justify-content-start">
                          {/* <img
                          className="me-2"
                          width={40}
                          src={personality.img_letter}
                          alt="personality-letter"
                        /> */}

                          {/* <h2
                          className="my-auto"
                          style={{ fontSize: "var(--font-size-h1)", fontWeight: "600" }}
                        >
                          {personality.personality}
                        </h2> */}
                        </div>
                        <div className="col-10 mx-auto">
                          <p className="text-base">{personality.text}</p>
                          <hr />
                        </div>
                        <div className="col-10 mx-auto mb-5">
                          <div className="row">
                            <div className="col-2">
                              <p className="text-base">
                                <strong>Strengths</strong>
                              </p>
                            </div>
                            <div className="col">
                              <p className="text-base">
                                {personality.strengths}
                              </p>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-2">
                              <p className="text-base">
                                <strong>Uniqueness</strong>
                              </p>
                            </div>
                            <div className="col">
                              <p className="text-base">
                                {personality.uniqueness}
                              </p>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-2">
                              <p
                                className="text-base text-nowrap"
                              >
                                <strong>Value to Org.</strong>
                              </p>
                            </div>
                            <div className="col">
                              <p className="text-base">
                                {personality.valtoorg}
                              </p>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-2">
                              <p
                                className="text-base text-nowrap"
                              >
                                <strong>Challenges</strong>
                              </p>
                            </div>
                            <div className="col">
                              <p className="text-base">
                                {personality.challenges}
                              </p>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-2">
                              <p className="text-base">
                                <strong>Motivations</strong>
                              </p>
                            </div>
                            <div className="col">
                              <p className="text-base">
                                {personality.motivations}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Modal.Body>

        </Modal>
      </div >
    </div >
  );
};

export default SupervisiorPersonality;
